export const categoriesBulkConfig = {
  tableName: 'categories',
  requiredFields: ['name'],
  fieldMappings: {
    name: {
      type: 'string',
      required: true,
      maxLength: 100,
      label: 'Category Name'
    },
    subcategories: {
      type: 'array',
      required: false,
      label: 'Subcategories',
      itemType: {
        name: {
          type: 'string',
          required: true,
          maxLength: 100,
          label: 'Subcategory Name'
        }
      }
    }
  },
  validateItem: (item) => {
    const errors = [];
    
    // Check required fields
    categoriesBulkConfig.requiredFields.forEach(field => {
      if (!item[field]) {
        errors.push(`${field} is required`);
      }
    });

    // Validate subcategories if present
    if (item.subcategories && Array.isArray(item.subcategories)) {
      item.subcategories.forEach((sub, index) => {
        if (!sub.name) {
          errors.push(`Subcategory at index ${index} must have a name`);
        } else if (sub.name.length > 100) {
          errors.push(`Subcategory name at index ${index} exceeds maximum length of 100 characters`);
        }
      });
    }

    return {
      isValid: errors.length === 0,
      errors
    };
  }
}; 